import React from 'react'
import Box from '@mui/material/Box'

const listActionGroupSx = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '6px',
    minHeight: 22,
    flexWrap: 'nowrap',
    lineHeight: 0,
    verticalAlign: 'middle',
}

// 목록이 저장/삭제 중일 때 Action 컬럼 전체 클릭을 막기 위한 공통 disabled 처리다.
const disabledActionGroupSx = {
    opacity: 0.5,
    pointerEvents: 'none',
}

// 테이블 Action 컬럼 아이콘 래퍼를 통일해 수정/삭제 간격과 기준선을 한 번에 맞춘다.
export default function ListActionGroup({ children, disabled = false, sx, ...props }) {
    return (
        <Box
            aria-disabled={disabled || undefined}
            sx={[listActionGroupSx, disabled && disabledActionGroupSx, sx]}
            {...props}
        >
            {children}
        </Box>
    )
}
